import { SystemPrivilege } from './constants';

export const GROUPED_PRIVILEGES = {
  // Event Management
  eventCreate: [SystemPrivilege.CreateEvent],
  eventClose: [
    SystemPrivilege.ViewClosedEvent,
    SystemPrivilege.ManageClosedEvent,
  ],
  eventEdit: [SystemPrivilege.EditEvent],
  eventDetail: [
    SystemPrivilege.EditEvent,
    SystemPrivilege.ViewEvent,
    SystemPrivilege.ViewPostEventReport,
  ],
  eventList: [SystemPrivilege.ViewEvent, SystemPrivilege.ViewPostEventReport],
  // User Management
  userCreate: [
    SystemPrivilege.CreateBoardUser,
    SystemPrivilege.CreateBrokerAdmin,
    SystemPrivilege.CreateBrokerUser,
    SystemPrivilege.CreateClientAdmin,
    SystemPrivilege.CreateClientUser,
    SystemPrivilege.CreateClubAdmin,
    SystemPrivilege.CreateClubUser,
    SystemPrivilege.CreateEventAdmin,
    SystemPrivilege.CreateEventUser,
    SystemPrivilege.CreateUnderwriterAdmin,
    SystemPrivilege.CreateUnderwriterUser,
  ],
  userEdit: [
    SystemPrivilege.EditBoardUser,
    SystemPrivilege.EditBrokerAdmin,
    SystemPrivilege.EditBrokerUser,
    SystemPrivilege.EditClientAdmin,
    SystemPrivilege.EditClientUser,
    SystemPrivilege.EditClubAdmin,
    SystemPrivilege.EditClubUser,
    SystemPrivilege.EditEventAdmin,
    SystemPrivilege.EditEventUser,
    SystemPrivilege.EditUnderwriterAdmin,
    SystemPrivilege.EditUnderwriterUser,
  ],
  userDetail: [
    SystemPrivilege.ViewBoardUser,
    SystemPrivilege.ViewBrokerAdmin,
    SystemPrivilege.ViewBrokerUser,
    SystemPrivilege.ViewClientAdmin,
    SystemPrivilege.ViewClientUser,
    SystemPrivilege.ViewClubAdmin,
    SystemPrivilege.ViewClubUser,
    SystemPrivilege.ViewEventAdmin,
    SystemPrivilege.ViewEventUser,
    SystemPrivilege.ViewUnderwriterAdmin,
    SystemPrivilege.ViewUnderwriterUser,
  ],
  userList: [
    SystemPrivilege.ViewBoardUser,
    SystemPrivilege.ViewBrokerAdmin,
    SystemPrivilege.ViewBrokerUser,
    SystemPrivilege.ViewClientAdmin,
    SystemPrivilege.ViewClientUser,
    SystemPrivilege.ViewClubAdmin,
    SystemPrivilege.ViewClubUser,
    SystemPrivilege.ViewEventAdmin,
    SystemPrivilege.ViewEventUser,
    SystemPrivilege.ViewUnderwriterAdmin,
    SystemPrivilege.ViewUnderwriterUser,
  ],
  viewReporting: [SystemPrivilege.ViewReporting],
};
